import { useCallback, useEffect, useState } from "react";
import axios from "utils/httpClient";
import { assignmentPeriod } from "./assignmentUtils";

export default function useAssignmentAvailability(assignment, excludeTurnId = null) {
  const period = assignmentPeriod(assignment);
  const start = period?.start.format("YYYY-MM-DDTHH:mm:ss") || "";
  const end = period?.end.format("YYYY-MM-DDTHH:mm:ss") || "";
  const [revision, setRevision] = useState(0);
  const key = `${start}|${end}|${excludeTurnId || ""}|${revision}`;
  const [state, setState] = useState({ key: "", data: null, loading: false, error: "" });
  const refresh = useCallback(() => setRevision(value => value + 1), []);
  useEffect(() => {
    if (!start || !end) return;
    let current = true;
    setState(previous => ({ ...previous, key, loading: true, error: "" }));
    axios.get("/api/v1/vehiclebooking/assignments/availability", {
      params: { startDatetime: start, endDatetime: end, ...(excludeTurnId ? { excludeTurnId } : {}) }
    }).then(response => {
      if (!current) return;
      if (response.data.result !== 200) throw new Error(response.data.msg || "ตรวจสอบรถและคนขับไม่สำเร็จ");
      setState({ key, data: response.data.data, loading: false, error: "" });
    }).catch(error => {
      if (current) setState(previous => ({ ...previous, key, loading: false,
        error: error.response?.data?.msg || "ตรวจสอบรถและคนขับไม่สำเร็จ กรุณาลองใหม่" }));
    });
    return () => { current = false; };
  }, [start, end, excludeTurnId, revision, key]);
  return {
    data: state.data, rangeValid: !!period,
    ready: !!period && state.key === key && !state.loading && !state.error,
    loading: !!period && (state.key !== key || state.loading),
    error: state.key === key ? state.error : "", refresh
  };
}
